function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-width: 1px;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M337,449c-0.4,4.03-.327,3.912-2,6v-5c-8.494-.727-13.4-1.694-13,5l-2-1c-5-27.593-29.975-30.822-41-52-14.276-27.423-5.285-43.1-2-71,14.283,1.334,14.232-4.9,26-9,14.809-5.156,43.214-7.029,63-4l115,5,50,6c3.5,39.8-10.4,90.465-39,101q1,11,2,22h-1c-4.35-3.128-14.739,2.8-17-6-6.73,1.189-12.738,4.831-21,2-4.578-1.569.06-4.263-6-4C413.572,445.539,368.278,447.951,337,449Zm157,3,1,3h-1v-3Z"
});

var SvgFHairstyleStraightShortBackVector = function SvgFHairstyleStraightShortBackVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f_hairstyle_straight_short_back_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFHairstyleStraightShortBackVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/f_hairstyle_straight_short_back_vector.1f418f92.svg";
export { ForwardRef as ReactComponent };